<template>
  <section>
    <p class="skin-title">{{
        title || getSkinsLabel(name) === 'Skins' ?
            $t('Skins') :
            $t('filters.weapon.' + getSkinsLabel(name))
      }}</p>
    <div class="case-items card card-dark">
      <p v-if="props.count" class="case-items__title">
        {{
          t('contains', {
            count: count || 'N/A',
            name: title || getSkinsLabel(name) === 'Skins' ?
                $t('Skins') :
                $t('filters.weapon.' + getSkinsLabel(name))
          })
        }}
      </p>
      <div :class="[items?.length  < 3 ? 'center' : '']" class="case-items__items">
        <img
            v-for="item in items?.length > 3
            ? [
                items[0],
                items.find(i => i.market_hash_name.toLowerCase().includes('case')) || items[Math.max(1, items.length - 2)],
                items[items.length - 1]
              ]
            : items"
            :key="item?.market_hash_name"
            :alt="item?.market_hash_name"
            :src="getImageFromWaxpeer(item?.market_hash_name, '200:200')"
            height="100"
            loading="lazy"
            width="150"
        >
      </div>
      <NuxtLink :to="getContainerLink({name, category, slug: link})" class="btn btn-primary">
        {{
          t('view_all_items', {
            n: (title || (getSkinsLabel(name) === 'Skins' ?
                $t('Skins') :
                $t('filters.weapon.' + getSkinsLabel(name))).toLowerCase())
          })
        }}
      </NuxtLink>
    </div>
  </section>
</template>

<script lang="ts" setup>
import {getContainerLink, getModifiedString} from "~/utils/name-utils";
import type {ContainerItem} from "~/graphql/generated/schema-types";

const props = defineProps<{
  items: ContainerItem[],
  count: number,
  title: string,
  name: string,
  category: string,
  link: string
}>()

const {t} = useI18n()

const getSkinsLabel = (hashName: string) => {
  hashName = getModifiedString(hashName)
  let label: string = '';

  if (
      props.category.toLowerCase().includes('autograph-capsule') || hashName.includes('autograph-capsule') || props.category.toLowerCase().includes('sticker') || hashName.includes('sticker')
  ) {
    label = 'Stickers'
  } else if (
      props.category.toLowerCase().includes('crates') ||
      hashName.includes('souvenir')
  ) {
    label = 'Skins'
  } else if (props.category.toLowerCase().includes('collection-package') || hashName.includes('collection-package')) {
    label = 'Crates'
  } else if (props.category.toLowerCase().includes('graffiti') || hashName.includes('graffiti')) {
    label = 'Graffities'
  } else if (props.category.toLowerCase().includes('music-kit-box') || hashName.includes('music-kit-box')) {
    label = 'Music Kits'
  } else if (props.category.toLowerCase().includes('case') || hashName.includes('case')) {
    label = 'Skins';
  } else if (props.category.toLowerCase().includes('pin') || hashName.includes('pin')) {
    label = 'Pins';
  } else if (props.category.toLowerCase().includes('patch') || hashName.includes('patch')) {
    label = 'Patches';
  } else if (props.category.toLowerCase().includes('collection') || hashName.includes('collection')) {
    label = 'Collections';
  } else {
    label = 'Skins';
  }
  return label
}
</script>

<style lang="scss" scoped>


.case-items {
  text-align: center;
  color: var(--surfaces-on-surface-variable);
  font-weight: 600;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 16px;

  &__items {
    display: grid;
    gap: 0.5rem;
    grid-template-columns: repeat(3, 1fr);

    &.center {
      display: flex;
      justify-content: center;
    }

    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
      object-position: center;
      max-height: 80px;
    }
  }
}
</style>
